import type { SortField, SortOrderDirection } from '../types';

// Interface for incoming sort state from the library
export interface SortOrderState {
  columnKey?: unknown;
  order?: unknown;
}

/**
 * Type guard to validate sort state
 * Ensures the incoming sort state from the table library has valid field and order values
 */
export const isValidSortState = (
  state: SortOrderState
): state is { columnKey: SortField; order: SortOrderDirection } => {
  const validSortFields: string[] = [
    'number',
    'created_at',
    'submitted_at',
    'book_date',
    'due_date',
    'approved_at',
  ];
  const validOrders: string[] = ['ascend', 'descend'];
  return (
    typeof state.columnKey === 'string' &&
    validSortFields.includes(state.columnKey) &&
    typeof state.order === 'string' &&
    validOrders.includes(state.order)
  );
};
